import { haveFilterQuery, paginator, haveSort } from '../common/auxFun'

const endpointsPricesFuelStations = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/fuelStations/prices/minetur/${haveFilterQuery(filter)}${paginator(
      limit,
      skip,
    )}${haveSort(sort)}`,
  CHANGEPRICE: `/v1/fuelStations/prices/minetur`,
  CENTER_PRICES: (id) =>
    `/v1/fuelStations/prices/minetur/ownstation/${id}/last`, // CAMBIAR ENDPOINT
}

const endpointsMineturPrices = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/fuelStations/prices/minetur/${haveFilterQuery(filter)}${paginator(
      limit,
      skip,
    )}${haveSort(sort)}`,
  CHANGEPRICE: `/v1/fuelStations/prices/minetur`,
  OWN_STATION: (id, filter, sort, limit, skip) =>
    `/v1/fuelStations/prices/minetur/ownstation/${id}/history/${haveFilterQuery(
      filter,
    )}${paginator(limit, skip)}${haveSort(sort)}`,
  OWN_STATIONS_LAST_PRICE: (id) =>
    `/v1/fuelStations/prices/minetur/ownstation/${id}/last`,
}

const endpointsAlvicPrices = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/fuelStations/prices/alvic/${haveFilterQuery(filter)}${paginator(
      limit,
      skip,
    )}${haveSort(sort)}`,
}

const endpointsSummaryFuelStations = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/fuelStations/summary/${haveFilterQuery(filter)}${paginator(
      limit,
      skip,
    )}${haveSort(sort)}`,
}

export {
  endpointsMineturPrices,
  endpointsAlvicPrices,
  endpointsSummaryFuelStations,
}

export default endpointsPricesFuelStations
